import cn from "classnames"
import { Link as LinkReactRouter } from "react-router-dom"

import styles from "./Link.module.scss"

import { LinkProps } from "."

export const Link = (props: LinkProps) => {
  const { to, children, type, state } = props
  const className = cn(props.className, {
    [styles.link]: type === "link",
    [styles.linkOnHover]: type === "link-hover"
  })

  if (to) {
    return (
      <LinkReactRouter
        to={to}
        state={state}
        className={className}
        discover="none"
      >
        {children}
      </LinkReactRouter>
    )
  }

  const { href, target, onClick } = props

  return (
    <a
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
      href={href}
      target={target}
      className={className}
      onClick={onClick}
    >
      {children}
    </a>
  )
}
